// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__loginPage--Paqom {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 40px 0;
  overflow: hidden;
  background-color: #343a41;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__content--dZupd {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 32px 32px 0;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__content--dZupd .ant-form {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__content--dZupd .ant-form-item-label {
  padding-bottom: 8px;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__content--dZupd .ant-form-item-label label {
  height: auto !important;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__formContainer--_FL2W {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  padding: 16px 16px 48px;
  overflow: auto;
  background-color: #ffffff;
  border-radius: 8px;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__langDiv--BZ556 {
  display: flex;
  justify-content: end;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__langSelect--P5VkY {
  width: max-content;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__loginCopyrightLabel--sIOi7 {
  font-size: 12px;
  color: #ffffff;
  position: absolute;
  bottom: 8px;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__logo--idIS9 {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  column-gap: 12px;
  padding-bottom: 22px;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__logo--idIS9 svg {
  height: 24px;
  width: 37px;
  color: #fc4807;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__logo--idIS9 .src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__logoText--N1P5t {
  font-size: 21px;
  line-height: 21px;
  font-weight: 700;
}
.src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__title--sYO1K {
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AuthChecker/overlays/CommonOverlay/CommonOverlay.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;AAAF;AAJA;EAOI,aAAA;EACA,sBAAA;EACA,aAAA;AAAJ;AATA;EAaI,mBAAA;AADJ;AAZA;EAgBM,uBAAA;AADN;AAKA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAHF;AAKA;EACE,aAAA;EACA,oBAAA;AAHF;AAKA;EACE,kBAAA;AAHF;AAKA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAHF;AAKA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AAHF;AAFA;EAOI,YAAA;EACA,WAAA;EACA,cAAA;AAFJ;AAPA;EAYI,eAAA;EACA,iBAAA;EACA,gBAAA;AAFJ;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHF","sourcesContent":[".loginPage {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  padding: 40px 0;\n  overflow: hidden;\n  background-color: #343a41;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n  padding: 32px 32px 0;\n\n  :global(.ant-form) {\n    display: flex;\n    flex-direction: column;\n    row-gap: 12px;\n  }\n\n  :global(.ant-form-item-label) {\n    padding-bottom: 8px;\n\n    label {\n      height: auto !important;\n    }\n  }\n}\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30%;\n  padding: 16px 16px 48px;\n  overflow: auto;\n  background-color: #ffffff;\n  border-radius: 8px;\n}\n.langDiv {\n  display: flex;\n  justify-content: end;\n}\n.langSelect {\n  width: max-content;\n}\n.loginCopyrightLabel {\n  font-size: 12px;\n  color: #ffffff;\n  position: absolute;\n  bottom: 8px;\n}\n.logo {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  column-gap: 12px;\n  padding-bottom: 22px;\n  svg {\n    height: 24px;\n    width: 37px;\n    color: #fc4807;\n  }\n  .logoText {\n    font-size: 21px;\n    line-height: 21px;\n    font-weight: 700;\n  }\n}\n.title {\n  text-align: center;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginPage": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__loginPage--Paqom`,
	"content": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__content--dZupd`,
	"formContainer": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__formContainer--_FL2W`,
	"langDiv": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__langDiv--BZ556`,
	"langSelect": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__langSelect--P5VkY`,
	"loginCopyrightLabel": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__loginCopyrightLabel--sIOi7`,
	"logo": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__logo--idIS9`,
	"logoText": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__logoText--N1P5t`,
	"title": `src-components-AuthChecker-overlays-CommonOverlay-CommonOverlay-module__title--sYO1K`
};
export default ___CSS_LOADER_EXPORT___;
